<template>
    <div class="mb-8 flex flex-col gap-2">
        <div class="
                              w-full
                              mb-4
                              text-gray-800
                              font-sm font-semibold
                              leading-10
                              flex-shrink-0
                            ">
            <label>Background</label>
        </div>
        <div class="mb-6 flex">
            <div class="w-16 text-gray-800 text-xs flex-shrink-0">
                <label>Color</label>
            </div>
            <div class="w-full">
                <div class="flex items-center">
                    <input @change="UpdateBackgroundDefault" :checked="config.background_default"
                        id="checked-corner_custom_color" type="checkbox" value=""
                        class="w-4 h-4 accent-success bg-gray-100 border-gray-200 rounded ">
                    <label for="checked-corner_custom_color" class="ml-2 text-sm font-medium text-grow"> Custom
                        color</label>
                </div>

                <div class="mt-4" v-if="config.background_default">
                    <div class="rounded-lg p-0.5 bg-[#7979831a] h-8 flex flex-shrink-0 mb-4">
                        <button type="button" class="
                                      flex-grow
                                      relative
                                      flex
                                      items-center
                                      justify-center
                                      cursor-pointer
                                      text-[#36374fcc]
                                      bg-transparent
                                      rounded-lg
                                      text-xs
                                      overflow-hidden
                                      transition-all
                                      duration-150
                                      ease-out
                                    " @click="setColorBackground" :class="{
                                        'font-semibold bg-white': config.backgroundOptions.color,
                                    }">
                            Solid
                        </button>
                        <button type="button" @click="setGradientBackground" class="
                                      flex-grow
                                      relative
                                      flex
                                      items-center
                                      justify-center
                                      cursor-pointer
                                      text-[#36374fcc]
                                      bg-transparent
                                      rounded-lg
                                      text-xs
                                      overflow-hidden
                                      transition-all
                                      duration-150
                                      ease-out
                                    " :class="{
                                        'font-semibold bg-white': config.backgroundOptions.gradient,
                                    }">
                            Gradient
                        </button>
                    </div>
                    <template v-if="config.backgroundOptions.color">
                        <div class="mb-4 flex gap-2">
                            <label class="w-14 flex-shrink-0 text-xs">Picker</label>
                            <div class="flex flex-wrap gap-1">
                                <color-picker v-model:pureColor="config.backgroundOptions.color" :format="'hex8'"
                                    :pickerType="'chrome'" :shape="'circle'" :isWidget="false" />
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <div class="flex gap-2 items-center mb-4">
                            <label class="w-14 flex-shrink-0 text-xs">Picker</label>
                            <div class="flex gap-2 items-center">
                                <color-picker v-model:pureColor="config.backgroundOptions.gradient.colorStops[0].color"
                                        :format="'hex8'" :pickerType="'chrome'" :shape="'circle'" :isWidget="false" />
                               
                                <ArrowRightIcon size="18" stroke-width="1" />
                                <color-picker v-model:pureColor="config.backgroundOptions.gradient.colorStops[1].color"
                                        :format="'hex8'" :pickerType="'chrome'" :shape="'circle'" :isWidget="false" />
                              
                            </div>
                        </div>
                        <div class="flex gap-2 items-center mb-4">
                            <label class="w-14 flex-shrink-0 text-xs">Type</label>
                            <div class="flex items-center gap-3">
                                <div class="flex items-center">
                                    <input id="gradient_type1x" type="radio" :value="'linear'"
                                        v-model="config.backgroundOptions.gradient.type" name="gradient_type"
                                        class="w-5 h-5 accent-success bg-gray-100 border-gray-300   ">
                                    <label for="gradient_type1x"
                                        class="w-full ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">Linear</label>
                                </div>
                                <div class="flex items-center ">
                                    <input id="gradient_type2x" :value="'radial'" type="radio"
                                        v-model="config.backgroundOptions.gradient.type" name="gradient_type"
                                        class="w-5 h-5 accent-success bg-gray-100 border-gray-300   ">
                                    <label for="gradient_type2x"
                                        class="w-full ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">Radial</label>
                                </div>
                            </div>

                        </div>
                        <div class="flex gap-2 items-center mb-4" v-if="config.backgroundOptions.gradient.type == 'linear'">
                            <label class="w-14 flex-shrink-0 text-xs">Rotation</label>
                            <input type="number" class="h-10 rounded-md bg-gray-200 outline-none px-2"
                                :value="config.backgroundOptions.gradient.rotation" @change="UpdateRotationGradient" />
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
import { PaletteIcon, ArrowRightIcon } from "vue-tabler-icons";
import { useQrCreateStore } from "~~/stores/qrcreate";
import configMixin from "../config.mixin";
export default {
    mixins:[configMixin],
    components: { PaletteIcon, ArrowRightIcon },
    data() {
        return {
            picker_modal: false,
        };
    },
    
    methods: {
        UpdateBackgroundDefault(e) {
            var status = e.target.checked;
            console.log(status)
            if (status) {
                if (this.config.backgroundOptions.gradient) {
                    this.setGradientBackground();
                } else {
                    this.setColorBackground();
                }
            } else {
                this.config.backgroundOptions = {
                    color:"transparent"
                }
            }
            this.config.background_default = (status);
        },
        setColorBackground() {
            var color = this.config.backgroundOptions.color;
            if (!color) {
                color = "#ffffff";
            }
            useQrCreateStore().setColorByKey({
                key: "backgroundOptions",
                color: color,
            });
        },
        setGradientBackground() {
            var gradient = this.config.backgroundOptions.gradient;
            if (!gradient) {
                gradient = {
                    type: "linear",
                    colorStops: [
                        { offset: 0, color: "#ffffff" },
                        { offset: 1, color: "#ffffff" },
                    ],
                    rotation: "0",
                };
            }
            useQrCreateStore().setGradientByKey({
                key: "backgroundOptions",
                data: JSON.parse(JSON.stringify(gradient)),
            });
            this.$forceUpdate();
        },
        closePopoverColor() {
            this.picker_modal = false;
        },
        changeColor({ color }) {
            useQrCreateStore().setColorByKey({
                key: "backgroundOptions",
                color: color,
            });
        },
        UpdateGradient1(e) {
            useQrCreateStore().setGradientByKey({
                key: "backgroundOptions",
                data: {
                    color1: e.target.value,
                },
            });
            this.$forceUpdate();
        },
        UpdateGradient2(e) {
            useQrCreateStore().setGradientByKey({
                key: "backgroundOptions",
                data: {
                    color2: e.target.value,
                },
            });
            this.$forceUpdate();
        },
        UpdateTypeGradient(e) {
            useQrCreateStore().setGradientByKey({
                key: "backgroundOptions",
                data: { mode: e.target.value },
            });
            this.$forceUpdate();
        },
        UpdateRotationGradient(e) {
            useQrCreateStore().setGradientByKey({
                key: "backgroundOptions",
                data: { rotation: e.target.value },
            });
        },
        changeBackgroundDefault(e){
            console.log(e)
        }
    },
};
</script>
  
<style></style>